export const URL_CONFIG = {
    loginApi: "/login",
    getSiteListApi: "/getsitelist",
    getSiteApi: "/getsitedata",
    getSiteLOB: "/get-sites-lob-oos",
    emailApi: "/sendemail",    
    favoriteSiteApi: "/favorites",
    selectedSiteApi: "/selectedsite"
}